import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/conhecimento')({
  component: KnowledgeLayout,
})

function KnowledgeLayout() {
  return <Outlet />
}
